import { DateTime } from 'luxon';

/** Fuso dos prazos e vencimentos do negócio (a API grava os instantes em UTC). */
export const BRAZIL_TIME_ZONE = 'America/Sao_Paulo';

/**
 * Formata uma data ISO para o formato brasileiro dd/mm/yyyy
 * @param dateString - Data no formato ISO (ex: "2025-12-01T13:47:14")
 * @param zone - Fuso em que o dia é lido. Sem ele, vale o do navegador. Use
 *   {@link BRAZIL_TIME_ZONE} para instantes UTC que representam um dia em
 *   Brasília (ex.: "fim do dia 18/11" chega como 2026-11-19T02:59:59Z).
 * @returns Data formatada no formato dd/mm/yyyy ou string vazia se inválida
 */
export function formatDateToBrazil(
  dateString: string | null | undefined,
  zone?: string
): string {
  if (!dateString) return '';

  try {
    const parsed = DateTime.fromISO(dateString);
    const date = zone ? parsed.setZone(zone) : parsed;

    if (!date.isValid) {
      return '';
    }

    return date.toFormat('dd/MM/yyyy');
  } catch {
    return '';
  }
}

/**
 * Formata uma data ISO para o formato brasileiro dd/mm/yyyy HH:mm:ss
 * @param dateString - Data no formato ISO (ex: "2025-12-01T13:47:14")
 * @returns Data formatada no formato dd/mm/yyyy HH:mm:ss ou string vazia se inválida
 */
export function formatDateTimeToBrazil(
  dateString: string | null | undefined
): string {
  if (!dateString) return '';

  try {
    const date = DateTime.fromISO(dateString);

    if (!date.isValid) {
      return '';
    }

    return date.toFormat('dd/MM/yyyy HH:mm:ss');
  } catch {
    return '';
  }
}

/**
 * Formata uma data ISO para dd/mm/yyyy HH:mm (sem segundos).
 *
 * Usado no histórico de atividades da cotação, onde a precisão de segundos
 * polui a leitura da trilha.
 * @param dateString - Data no formato ISO (ex: "2025-12-01T13:47:14")
 * @param zone - Fuso em que a hora é lida. Sem ele, vale o do navegador. Use
 *   {@link BRAZIL_TIME_ZONE} para mostrar a hora de Brasília.
 * @returns Data formatada no formato dd/mm/yyyy HH:mm ou string vazia se inválida
 */
export function formatDateTimeShortToBrazil(
  dateString: string | null | undefined,
  zone?: string
): string {
  if (!dateString) return '';

  try {
    const parsed = DateTime.fromISO(dateString);
    const date = zone ? parsed.setZone(zone) : parsed;

    if (!date.isValid) {
      return '';
    }

    return date.toFormat('dd/MM/yyyy HH:mm');
  } catch {
    return '';
  }
}
